export default [
	//propostas
	{ id: 'PROPOSTA_SMS', txt: 'PROPOSTA SMS', grupo: 'proposta' },
	{ id: 'PROPOSTA_PADRAO', txt: 'PROPOSTA PADRÃO', grupo: 'proposta' },
	{ id: 'PROPOSTA_OFFSHORE', txt: 'PROPOSTA OFFSHORE', grupo: 'proposta' },
	{ id: 'PROPOSTA_MARITIMO', txt: 'PROPOSTA OFFSHORE', grupo: 'proposta' },

	//Contratos
	{ id: 'CONTRATO_SMS', txt: 'CONTRATO SMS', grupo: 'contrato' },
	{ id: 'CONTRATO_PADRAO', txt: 'CONTRATO PADRÃO', grupo: 'contrato' },
	{ id: 'CONTRATO_OFFSHORE', txt: 'CONTRATO OFFSHORE', grupo: 'contrato' },
	{ id: 'CONTRATO_MARITIMO', txt: 'CONTRATO MARÍTIMO', grupo: 'contrato' },

	//outros
	{ id: 'OUTROS', txt: 'OUTROS', grupo: 'outros' },
	{ id: 'OS', txt: 'ORDEM DE SERVICO', grupo: 'ordem_servico' },
];



// WEBPACK FOOTER //
// ./src/assets/js/docsType.js